/** The type definition for the data model of an S3 export build result. */
export class S3ExportBuildResult {
    constructor(data) {
        this.url = data.url;
    }
}
/** The type definition for the data model of an export build pull request result. */
export class ExportBuildPullRequestResult {
    constructor(data) {
        this.pullRequestUrl = data.pullRequestUrl;
    }
}
/** The type definition for documentation build's result. */
export class ExportBuildDocumentationResult {
    constructor(data) {
        this.url = data.url;
    }
}
/**
 * The enum representing possible types of export build result logs.
 * @enum {string}
 */
export var ExportBuildResultLogType;
(function (ExportBuildResultLogType) {
    ExportBuildResultLogType["success"] = "success";
    ExportBuildResultLogType["info"] = "info";
    ExportBuildResultLogType["warning"] = "warning";
    ExportBuildResultLogType["user"] = "user";
    ExportBuildResultLogType["error"] = "error";
})(ExportBuildResultLogType || (ExportBuildResultLogType = {}));
export class ExportBuildResultLog {
    constructor(data) {
        this.time = new Date(data.time);
        this.type = data.type;
        this.message = data.message;
    }
}
export class ExportBuildResult {
    constructor(data) {
        this.logs = data.logs;
        this.s3 = data.s3;
        this.azure = data.azure;
        this.bitbucket = data.bitbucket;
        this.github = data.github;
        this.gitlab = data.gitlab;
        this.documentation = data.documentation;
        this.error = data.error;
    }
}
